import { abyssColors, primary } from '@/theme/colors';
import { Accordion, Box, alpha } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

export const riskAssessmentStack = {
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
};

export const riskAssessmentContainer = {
  backgroundColor: '#F8FBFD',
  padding: '3.2rem',
  border: `1px solid ${alpha('#6e8198', 0.25)}`,
  borderRadius: '0.8rem',
};

export const tabScreenStyles = {
  p: 4,
  mt: 2,
  position: 'relative',
  height: 'calc(65vh / var(--zoom) - 65px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
  background: abyssColors.neutral[50],
  border: `1px solid ${alpha('#6e8198', 0.25)}`,
  overflow: 'hidden',
};

export const filterPaperStyles = {
  p: 4,
  mt: 2,
  position: 'relative',
  height: 'calc(65vh / var(--zoom) - 65px)',
  overflowY: 'auto',
  background: abyssColors.neutral[50],
  border: `1px solid ${alpha('#6e8198', 0.25)}`,
};

export const commentsDrawer = {
  height: '100vh',
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    pt: 2,
    width: 'calc(20vw / var(--zoom) - 20px)',
    boxSizing: 'border-box',
    position: 'absolute',
    backgroundColor: 'rgb(184, 184, 184, 0.1)',
  },
};

export const RiskAccordian = muiStyled(Accordion)(() => ({
  background: 'none',
  '&::before': {
    opacity: 0,
  },
  '& .MuiAccordionSummary-root': {
    margin: 0,
    minHeight: 'min-content',
  },
}));

export const AccordianToggleButton = muiStyled(Box)(() => ({
  width: '3.2rem',
  height: '3.2rem',
  background: primary.blue,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '0.4rem',
  color: 'white',
  cursor: 'pointer',
  '& svg': {
    transition: 'transform 0.3s',
  },
}));
